export type SeriesKey =
  | 'temperature'
  | 'humidity'
  | 'powerSupply'
  | 'batteryVoltage'
  | 'batteryStatus'
  | 'xAxis'
  | 'yAxis'
  | 'zAxis'
  | 'magnitude'
  | 'magnitudeNoGravity'
  | 'wagoEnergyActive'
  | 'wagoEnergyReactive'
  | 'wagoPowerL1'
  | 'wagoPowerL2'
  | 'wagoPowerL3'
  | 'wagoCurrentL1'
  | 'wagoCurrentL2'
  | 'wagoCurrentL3'
  | 'wagoVoltLNL1'
  | 'wagoVoltLNL2'
  | 'wagoVoltLNL3'
  | 'wagoVoltLLL1L2'
  | 'wagoVoltLLL2L3'
  | 'wagoVoltLLL1L3'
  | 'wagoPfL1'
  | 'wagoPfL2'
  | 'wagoPfL3'
  | 'dknLmsSv'
  | 'dknLmsSc'
  | 'dknLmsDfs'
  | 'dknLmsAlr'
  | 'dknLmsVsr'
  | 'dknLmsSh'
  | 'dknLmsPpu'
  | 'dknLmsShb'
  | 'dknLmsPpub'
  | 'dknLmsTgs'
  | 'dknLmsTeu'
  | 'dknLmsTeub'
  | 'dknLmsTgsb'
  | 'dknLmsSdt'
  | 'dknLmsSdtb'
  | 'dknLmsScb'
  | 'dknLmsSt'
  | 'dknLmsAh'
  | 'dknLmsAl'
  | 'dknLmsR4'
  | 'dknLmsD2'
  | 'dknLmsDfm'
  | 'dknLmsDas'
  | 'dknLmsCht'
  | 'dknLmsFia'
  | 'dknLmsFoi'
  | 'dknLmsFot'
  | 'dknLmsGlo'
  | 'dknLmsHi'
  | 'dknLmsU1'
  | 'dknMpsProbe1'
  | 'dknMpsProbe2'
  | 'dknMpsDisplayedProbe'
  | 'dknMpsTempRegProbe'
  | 'dknMpsSetpoint'
  | 'dknMpsSetpointActive'
  | 'dknMpsStatusDefrost'
  | 'dknMpsStatusOnOff'
  | 'dknMpsStatusCooling'
  | 'dknMpsDiDoor'
  | 'dknMpsDoComp1'
  | 'dknMpsDoComp2'
  | 'dknMpsDoEvapFan'
  | 'dknMpsAlarmHighTemp'
  | 'dknMpsAlarmLowTemp'
  | 'devPowerSupply'
  | 'devBattery'
  // DKN UART D10
  | 'dknUartD10OperationMode'
  | 'dknUartD10ThermostatOnOff'
  | 'dknUartD10Defrost'
  | 'dknUartD10DemandSignal'
  | 'dknUartD10RestartStandby'
  | 'dknUartD10OilReturn'
  | 'dknUartD10PressureEqualizing'
  | 'dknUartD10ModeCompletion'
  | 'dknUartD10LowNoiseControl'
  | 'dknUartD10ErrorType'
  | 'dknUartD10ErrorCode'
  | 'dknUartD10SoftwareVersion'
  | 'dknUartD10TargetEvapPress'
  // DKN UART D10 — protection
  | 'dknUartD10DischargeTempDrop'
  | 'dknUartD10DischargeTempRetries'
  | 'dknUartD10CompInvCurrentDrop'
  | 'dknUartD10CompInvCurrentRetries'
  | 'dknUartD10HpDrop'
  | 'dknUartD10HpRetries'
  | 'dknUartD10LpDrop'
  | 'dknUartD10LpRetries'
  | 'dknUartD10FinTempDrop'
  | 'dknUartD10FinTempRetries'
  | 'dknUartD10OtherDrop'
  // DKN UART D20
  | 'dknUartD20OutdoorAirTemp'
  | 'dknUartD20Ti'
  | 'dknUartD20Tl'
  | 'dknUartD20Tg'
  | 'dknUartD20Td1'
  | 'dknUartD20LowPressure1'
  | 'dknUartD20LowPressure1T'
  // DKN UART D21
  | 'dknUartD21HighPressure'
  | 'dknUartD21HighPressureT'
  | 'dknUartD21InvCurrent'
  | 'dknUartD21InvFinTemp'
  // DKN UART D30
  | 'dknUartD30CompressorFreq'
  | 'dknUartD30Fan1'
  | 'dknUartD30Fan2'
  | 'dknUartD30R1'
  | 'dknUartD30Warning'
  | 'dknUartD30BackUp'
  | 'dknUartD30Ev2'
  | 'dknUartD30Ev3'
  // DKN UART D50
  | 'dknUartD50OperationMode'
  | 'dknUartD50ErrorCode'
  | 'dknUartD50Setpoint'
  | 'dknUartD50SuctionTemp'
  | 'dknUartD50LiquidTemp'
  | 'dknUartD50GasTemp'
  | 'dknUartD50IndoorEv'
  // DKN UART D70
  | 'dknUartD70Ti'
  | 'dknUartD70Tg'
  | 'dknUartD70Td'
  | 'dknUartD70LowPressure'
  | 'dknUartD70LowPressureT'
  | 'dknUartD70CompressorFreq'
  // DKN UART — computed / derived
  | 'dknUartSuctionSh'
  | 'dknUartDischargeSh'

export type RawChartPoint = {
  x: number
  y: number | string | null | undefined
}

export type ChartPoint = {
  x: number
  y: number
}

export type RawChartSeriesPayload = {
  paramName?: string
  label?: string
  unit?: string
  points?: RawChartPoint[] | null
}

export type RawChartSeriesMap = Partial<Record<SeriesKey, RawChartSeriesPayload>>

export type ChartSeriesPayload = {
  paramName: string
  label: string
  unit: string
  points: ChartPoint[]
}

export type ChartSeriesRecord = Record<SeriesKey, ChartSeriesPayload>

type SeriesMeta = {
  paramName: string
  labelKey: string
  unit: string
  color: string
  axisId: string
  axisPosition: 'left' | 'right'
  axisTitle?: string
  offset?: boolean
  stepSize?: number
  tickFormatter?: (value: number) => string
}

export const SERIES_META: Record<SeriesKey, SeriesMeta> = {
  temperature: {
    paramName: 'TL_EYE_TEMPERATURE',
    labelKey: 'components.assets.dataGrids.temperature',
    unit: '°C',
    color: 'rgba(246, 127, 1, 0.85)',
    axisId: 'temperature',
    axisPosition: 'left',
    tickFormatter: (value) => `${value} °C`
  },
  humidity: {
    paramName: 'TL_EYE_HUMIDITY',
    labelKey: 'components.assets.dataGrids.humidity',
    unit: '%',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'humidity',
    axisPosition: 'left',
    offset: true,
    tickFormatter: (value) => `${value} %`
  },
  powerSupply: {
    paramName: 'TL_EYE_POWER_SUPPLY',
    labelKey: 'components.assets.dataGrids.power',
    unit: 'V',
    color: 'rgba(16, 185, 129, 0.85)',
    axisId: 'powerSupply',
    axisPosition: 'left',
    tickFormatter: (value) => `${Number(value).toFixed(2)} V`
  },
  batteryVoltage: {
    paramName: 'TL_EYE_BATTERY_VOLTAGE',
    labelKey: 'components.assets.dataGrids.batteryVoltage',
    unit: 'V',
    color: 'rgba(124, 58, 237, 0.85)',
    axisId: 'batteryVoltage',
    axisPosition: 'left',
    offset: true,
    tickFormatter: (value) => `${Number(value).toFixed(2)} V`
  },
  batteryStatus: {
    paramName: 'TL_EYE_LOW_BATTERY',
    labelKey: 'components.assets.dataGrids.batteryStatus',
    unit: '',
    color: 'rgba(220, 38, 38, 0.85)',
    axisId: 'batteryStatus',
    axisPosition: 'right'
  },
  xAxis: {
    paramName: 'X_AXIS',
    labelKey: 'components.assets.dataGrids.xAxis',
    unit: 'mG',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'axis',
    axisPosition: 'left'
  },
  yAxis: {
    paramName: 'Y_AXIS',
    labelKey: 'components.assets.dataGrids.yAxis',
    unit: 'mG',
    color: 'rgba(16, 185, 129, 0.85)',
    axisId: 'axis',
    axisPosition: 'left'
  },
  zAxis: {
    paramName: 'Z_AXIS',
    labelKey: 'components.assets.dataGrids.zAxis',
    unit: 'mG',
    color: 'rgba(246, 127, 1, 0.85)',
    axisId: 'axis',
    axisPosition: 'left'
  },
  magnitude: {
    paramName: 'DERIVED_MAGNITUDE',
    labelKey: 'components.assets.dataGrids.magnitude',
    unit: 'mG',
    color: 'rgba(71, 85, 105, 0.85)',
    axisId: 'axis',
    axisPosition: 'left'
  },
  magnitudeNoGravity: {
    paramName: 'DERIVED_MAGNITUDE_NO_GRAVITY',
    labelKey: 'components.assets.dataGrids.magnitudeNoGravity',
    unit: 'mG',
    color: 'rgba(13, 148, 136, 0.85)',
    axisId: 'axis',
    axisPosition: 'left'
  },
  // WAGO — Energy
  wagoEnergyActive: {
    paramName: 'WAGO_6000_E_ACT_TOTAL',
    labelKey: 'components.assetDetails.wagoLabels.energy_active',
    unit: 'kWh',
    color: 'rgba(16, 185, 129, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoEnergyReactive: {
    paramName: 'WAGO_6024_E_REACT_TOTAL',
    labelKey: 'components.assetDetails.wagoLabels.energy_reactive',
    unit: 'kvarh',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  // WAGO — Power
  wagoPowerL1: {
    paramName: 'WAGO_5014_P_ACT_L1',
    labelKey: 'components.assetDetails.wagoLabels.power_l1',
    unit: 'kW',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoPowerL2: {
    paramName: 'WAGO_5016_P_ACT_L2',
    labelKey: 'components.assetDetails.wagoLabels.power_l2',
    unit: 'kW',
    color: 'rgba(246, 127, 1, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoPowerL3: {
    paramName: 'WAGO_5018_P_ACT_L3',
    labelKey: 'components.assetDetails.wagoLabels.power_l3',
    unit: 'kW',
    color: 'rgba(220, 38, 38, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  // WAGO — Current
  wagoCurrentL1: {
    paramName: 'WAGO_500C_CURRENT_L1',
    labelKey: 'components.assetDetails.wagoLabels.current_l1',
    unit: 'A',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoCurrentL2: {
    paramName: 'WAGO_500E_CURRENT_L2',
    labelKey: 'components.assetDetails.wagoLabels.current_l2',
    unit: 'A',
    color: 'rgba(246, 127, 1, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoCurrentL3: {
    paramName: 'WAGO_5010_CURRENT_L3',
    labelKey: 'components.assetDetails.wagoLabels.current_l3',
    unit: 'A',
    color: 'rgba(220, 38, 38, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  // WAGO — Voltage L-N
  wagoVoltLNL1: {
    paramName: 'WAGO_5002_VOLTAGE_L1',
    labelKey: 'components.assetDetails.wagoLabels.voltage_ln_l1',
    unit: 'V',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoVoltLNL2: {
    paramName: 'WAGO_5004_VOLTAGE_L2',
    labelKey: 'components.assetDetails.wagoLabels.voltage_ln_l2',
    unit: 'V',
    color: 'rgba(246, 127, 1, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoVoltLNL3: {
    paramName: 'WAGO_5006_VOLTAGE_L3',
    labelKey: 'components.assetDetails.wagoLabels.voltage_ln_l3',
    unit: 'V',
    color: 'rgba(220, 38, 38, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  // WAGO — Voltage L-L
  wagoVoltLLL1L2: {
    paramName: 'WAGO_5032_VOLT_L1L2',
    labelKey: 'components.assetDetails.wagoLabels.voltage_ll_l1l2',
    unit: 'V',
    color: 'rgba(14, 116, 144, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoVoltLLL2L3: {
    paramName: 'WAGO_5036_VOLT_L2L3',
    labelKey: 'components.assetDetails.wagoLabels.voltage_ll_l2l3',
    unit: 'V',
    color: 'rgba(71, 85, 105, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoVoltLLL1L3: {
    paramName: 'WAGO_5034_VOLT_L1L3',
    labelKey: 'components.assetDetails.wagoLabels.voltage_ll_l1l3',
    unit: 'V',
    color: 'rgba(124, 58, 237, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  // WAGO — Power Factor
  wagoPfL1: {
    paramName: 'WAGO_502C_PF_L1',
    labelKey: 'components.assetDetails.wagoLabels.pf_l1',
    unit: '',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoPfL2: {
    paramName: 'WAGO_502E_PF_L2',
    labelKey: 'components.assetDetails.wagoLabels.pf_l2',
    unit: '',
    color: 'rgba(246, 127, 1, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },
  wagoPfL3: {
    paramName: 'WAGO_5030_PF_L3',
    labelKey: 'components.assetDetails.wagoLabels.pf_l3',
    unit: '',
    color: 'rgba(220, 38, 38, 0.85)',
    axisId: 'y',
    axisPosition: 'left'
  },

  dknLmsSv: {
    paramName: 'DKN_LMS_SV',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SV',
    unit: '°C',
    color: 'rgba(14, 116, 144, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsSc: {
    paramName: 'DKN_LMS_SC',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SC',
    unit: '°C',
    color: 'rgba(2, 132, 199, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsDfs: {
    paramName: 'DKN_LMS_DFS',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_DFS',
    unit: '',
    color: 'rgba(100, 116, 139, 0.85)',
    axisId: 'dknStatus',
    axisPosition: 'right',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsAlr: {
    paramName: 'DKN_LMS_ALR',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_ALR',
    unit: '',
    color: 'rgba(220, 38, 38, 0.85)',
    axisId: 'dknStatus',
    axisPosition: 'right',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsVsr: {
    paramName: 'DKN_LMS_VSR',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_VSR',
    unit: 'Hz',
    color: 'rgba(16, 185, 129, 0.85)',
    axisId: 'dknHz',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.frequency'
  },
  dknLmsSh: {
    paramName: 'DKN_LMS_SH',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SH',
    unit: 'K',
    color: 'rgba(56, 189, 248, 0.85)',
    axisId: 'dknK',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.superheat'
  },
  dknLmsPpu: {
    paramName: 'DKN_LMS_PPU',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_PPU',
    unit: '%',
    color: 'rgba(234, 179, 8, 0.85)',
    axisId: 'dknPercent',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.openingPercent'
  },
  dknLmsShb: {
    paramName: 'DKN_LMS_SHB',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SHB',
    unit: 'K',
    color: 'rgba(125, 211, 252, 0.85)',
    axisId: 'dknK',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.superheat'
  },
  dknLmsPpub: {
    paramName: 'DKN_LMS_PPUB',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_PPUB',
    unit: '%',
    color: 'rgba(250, 204, 21, 0.85)',
    axisId: 'dknPercent',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.openingPercent'
  },
  dknLmsTgs: {
    paramName: 'DKN_LMS_TGS',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_TGS',
    unit: '°C',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsTeu: {
    paramName: 'DKN_LMS_TEU',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_TEU',
    unit: '°C',
    color: 'rgba(14, 165, 233, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsTeub: {
    paramName: 'DKN_LMS_TEUB',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_TEUB',
    unit: '°C',
    color: 'rgba(6, 182, 212, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsTgsb: {
    paramName: 'DKN_LMS_TGSB',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_TGSB',
    unit: '°C',
    color: 'rgba(8, 145, 178, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsSdt: {
    paramName: 'DKN_LMS_SDT',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SDT',
    unit: '°C',
    color: 'rgba(239, 68, 68, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsSdtb: {
    paramName: 'DKN_LMS_SDTB',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SDTB',
    unit: '°C',
    color: 'rgba(248, 113, 113, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsScb: {
    paramName: 'DKN_LMS_SCB',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_SCB',
    unit: '°C',
    color: 'rgba(30, 64, 175, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknLmsSt: {
    paramName: 'DKN_LMS_ST',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_ST',
    unit: '°C',
    color: 'rgba(16, 185, 129, 0.95)',
    axisId: 'dknTempRef',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.thresholds'
  },
  dknLmsAh: {
    paramName: 'DKN_LMS_AH',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_AH',
    unit: '°C',
    color: 'rgba(251, 146, 60, 0.95)',
    axisId: 'dknTempRef',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.thresholds'
  },
  dknLmsAl: {
    paramName: 'DKN_LMS_AL',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_AL',
    unit: '°C',
    color: 'rgba(59, 130, 246, 0.95)',
    axisId: 'dknTempRef',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.thresholds'
  },
  dknLmsR4: {
    paramName: 'DKN_LMS_R4',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_R4',
    unit: '°C',
    color: 'rgba(124, 58, 237, 0.95)',
    axisId: 'dknTempRef',
    axisPosition: 'right',
    axisTitle: 'components.assetDetails.dknAxisTitles.thresholds'
  },
  dknLmsD2: {
    paramName: 'DKN_LMS_D2',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_D2',
    unit: '',
    color: 'rgba(71, 85, 105, 0.9)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsDfm: {
    paramName: 'DKN_LMS_DFM',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_DFM',
    unit: '',
    color: 'rgba(14, 165, 233, 0.9)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsDas: {
    paramName: 'DKN_LMS_DAS',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_DAS',
    unit: '',
    color: 'rgba(34, 197, 94, 0.9)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsCht: {
    paramName: 'DKN_LMS_CHT',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_CHT',
    unit: '',
    color: 'rgba(245, 158, 11, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsFia: {
    paramName: 'DKN_LMS_FIA',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_FIA',
    unit: '',
    color: 'rgba(220, 38, 38, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsFoi: {
    paramName: 'DKN_LMS_FOI',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_FOI',
    unit: '',
    color: 'rgba(56, 189, 248, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsFot: {
    paramName: 'DKN_LMS_FOT',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_FOT',
    unit: '',
    color: 'rgba(99, 102, 241, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsGlo: {
    paramName: 'DKN_LMS_GLO',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_GLO',
    unit: '',
    color: 'rgba(236, 72, 153, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsHi: {
    paramName: 'DKN_LMS_HI',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_HI',
    unit: '',
    color: 'rgba(239, 68, 68, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknLmsU1: {
    paramName: 'DKN_LMS_U1',
    labelKey: 'components.assetDetails.dknLabels.DKN_LMS_U1',
    unit: '',
    color: 'rgba(168, 85, 247, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },

  // DKN MPS — temperatures
  dknMpsProbe1: {
    paramName: 'DKN_MPS_PROBE_1',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_PROBE_1',
    unit: '°C',
    color: 'rgba(14, 116, 144, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknMpsProbe2: {
    paramName: 'DKN_MPS_PROBE_2',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_PROBE_2',
    unit: '°C',
    color: 'rgba(2, 132, 199, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknMpsDisplayedProbe: {
    paramName: 'DKN_MPS_DISPLAYED_PROBE',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_DISPLAYED_PROBE',
    unit: '°C',
    color: 'rgba(234, 88, 12, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  dknMpsTempRegProbe: {
    paramName: 'DKN_MPS_TEMP_REGULATION_PROBE',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_TEMP_REGULATION_PROBE',
    unit: '°C',
    color: 'rgba(21, 128, 61, 0.85)',
    axisId: 'dknTemp',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.temperature'
  },
  // DKN MPS — setpoints
  dknMpsSetpoint: {
    paramName: 'DKN_MPS_REAL_REGULATION_SETPOINT',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_REAL_REGULATION_SETPOINT',
    unit: '°C',
    color: 'rgba(16, 185, 129, 0.95)',
    axisId: 'dknTempRef',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.thresholds'
  },
  dknMpsSetpointActive: {
    paramName: 'DKN_MPS_SETPOINT_ACTIVE_MAP',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_SETPOINT_ACTIVE_MAP',
    unit: '°C',
    color: 'rgba(251, 146, 60, 0.95)',
    axisId: 'dknTempRef',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.thresholds'
  },
  // DKN MPS — status flags
  dknMpsStatusDefrost: {
    paramName: 'DKN_MPS_STATUS_DEFROST',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_STATUS_DEFROST',
    unit: '',
    color: 'rgba(100, 116, 139, 0.85)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknMpsStatusOnOff: {
    paramName: 'DKN_MPS_STATUS_ON_OFF',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_STATUS_ON_OFF',
    unit: '',
    color: 'rgba(16, 185, 129, 0.85)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknMpsStatusCooling: {
    paramName: 'DKN_MPS_STATUS_COOLING_REQUEST',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_STATUS_COOLING_REQUEST',
    unit: '',
    color: 'rgba(59, 130, 246, 0.85)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknMpsDiDoor: {
    paramName: 'DKN_MPS_DI_DOOR_STATUS',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_DI_DOOR_STATUS',
    unit: '',
    color: 'rgba(245, 158, 11, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  // DKN MPS — output flags
  dknMpsDoComp1: {
    paramName: 'DKN_MPS_DO_COMPRESSOR_OUTPUT_1',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_DO_COMPRESSOR_OUTPUT_1',
    unit: '',
    color: 'rgba(14, 165, 233, 0.9)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknMpsDoComp2: {
    paramName: 'DKN_MPS_DO_COMPRESSOR_OUTPUT_2',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_DO_COMPRESSOR_OUTPUT_2',
    unit: '',
    color: 'rgba(6, 182, 212, 0.9)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknMpsDoEvapFan: {
    paramName: 'DKN_MPS_DO_EVAP_FAN_OUTPUT_STATUS',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_DO_EVAP_FAN_OUTPUT_STATUS',
    unit: '',
    color: 'rgba(56, 189, 248, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  // DKN MPS — alarm flags
  dknMpsAlarmHighTemp: {
    paramName: 'DKN_MPS_ALARM_HIGH_TEMP_1',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_ALARM_HIGH_TEMP_1',
    unit: '',
    color: 'rgba(220, 38, 38, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknMpsAlarmLowTemp: {
    paramName: 'DKN_MPS_ALARM_LOW_TEMP_1',
    labelKey: 'components.assetDetails.mpsLabels.DKN_MPS_ALARM_LOW_TEMP_1',
    unit: '',
    color: 'rgba(59, 130, 246, 0.95)',
    axisId: 'dknStatus',
    axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  devPowerSupply: {
    paramName: 'DEV_POWER_SUPPLY_VOLTAGE',
    labelKey: 'components.assetDetails.gatewayLabels.DEV_POWER_SUPPLY_VOLTAGE',
    unit: 'V',
    color: 'rgba(16, 185, 129, 0.85)',
    axisId: 'gatewayVoltage',
    axisPosition: 'left',
    stepSize: 0.5,
    tickFormatter: (value) => `${Number(value).toFixed(2)} V`
  },
  devBattery: {
    paramName: 'DEV_BATTERY_VOLTAGE',
    labelKey: 'components.assetDetails.gatewayLabels.DEV_BATTERY_VOLTAGE',
    unit: 'V',
    color: 'rgba(234, 179, 8, 0.85)',
    axisId: 'gatewayBattery',
    axisPosition: 'right',
    stepSize: 0.1,
    tickFormatter: (value) => `${Number(value).toFixed(2)} V`
  },
  // DKN UART D10 — status & errors
  dknUartD10OperationMode: {
    paramName: 'DKN_UART_D10_OPERATION_MODE_C152_O0_B1',
    labelKey: 'components.assetDetails.dknUartLabels.operationMode',
    unit: '', color: 'rgba(99, 102, 241, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10ThermostatOnOff: {
    paramName: 'DKN_UART_D10_THERMOSTAT_ON_OFF_C307_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.thermostatOnOff',
    unit: '', color: 'rgba(139, 92, 246, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10Defrost: {
    paramName: 'DKN_UART_D10_DEFROST_OPERATION_C304_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.defrost',
    unit: '', color: 'rgba(59, 130, 246, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10DemandSignal: {
    paramName: 'DKN_UART_D10_DEMAND_SIGNAL_C301_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.demandSignal',
    unit: '', color: 'rgba(16, 185, 129, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10ErrorType: {
    paramName: 'DKN_UART_D10_ERROR_TYPE_C203_O4_B1',
    labelKey: 'components.assetDetails.dknUartLabels.errorType',
    unit: '', color: 'rgba(239, 68, 68, 0.9)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD10ErrorCode: {
    paramName: 'DKN_UART_D10_ERROR_CODE_C204_O5_B1',
    labelKey: 'components.assetDetails.dknUartLabels.errorCode',
    unit: '', color: 'rgba(220, 38, 38, 0.9)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD10SoftwareVersion: {
    paramName: 'DKN_UART_D10_SOFTWARE_VERSION_C151_O13_B2',
    labelKey: 'components.assetDetails.dknUartLabels.softwareVersion',
    unit: '', color: 'rgba(156, 163, 175, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  // DKN UART D10 — additional flags
  dknUartD10RestartStandby: {
    paramName: 'DKN_UART_D10_RESTART_STANDBY_C306_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.restartStandby',
    unit: '', color: 'rgba(20, 184, 166, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10OilReturn: {
    paramName: 'DKN_UART_D10_OIL_RETURN_OPERATION_C303_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.oilReturnOperation',
    unit: '', color: 'rgba(245, 158, 11, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10PressureEqualizing: {
    paramName: 'DKN_UART_D10_PRESSURE_EQUALIZING_OPERATION_C302_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.pressureEqualizingOperation',
    unit: '', color: 'rgba(168, 85, 247, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10ModeCompletion: {
    paramName: 'DKN_UART_D10_MODE_COMPLETION_C305_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.modeCompletion',
    unit: '', color: 'rgba(34, 197, 94, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10LowNoiseControl: {
    paramName: 'DKN_UART_D10_LOW_NOISE_CONTROL_C300_O1_B1',
    labelKey: 'components.assetDetails.dknUartLabels.lowNoiseControl',
    unit: '', color: 'rgba(14, 165, 233, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  // DKN UART D10 — target evap pressure
  dknUartD10TargetEvapPress: {
    paramName: 'DKN_UART_D10_TARGET_EVAP_PRESS_C116_O6_B2',
    labelKey: 'components.assetDetails.dknUartLabels.targetEvapPress',
    unit: 'bar', color: 'rgba(99, 102, 241, 0.75)', axisId: 'dknUartPressure', axisPosition: 'left',
    tickFormatter: (v) => `${v} bar`
  },
  // DKN UART D10 — protection drop flags
  dknUartD10DischargeTempDrop: {
    paramName: 'DKN_UART_D10_DISCHARGE_TEMP_DROP_C307_O10_B1',
    labelKey: 'components.assetDetails.dknUartLabels.dischargeTempDrop',
    unit: '', color: 'rgba(239, 68, 68, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10CompInvCurrentDrop: {
    paramName: 'DKN_UART_D10_COMP_INV_CURRENT_DROP_C303_O10_B1',
    labelKey: 'components.assetDetails.dknUartLabels.compInvCurrentDrop',
    unit: '', color: 'rgba(249, 115, 22, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10HpDrop: {
    paramName: 'DKN_UART_D10_HP_DROP_CONTROL_C307_O11_B1',
    labelKey: 'components.assetDetails.dknUartLabels.hpDropControl',
    unit: '', color: 'rgba(132, 204, 22, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10LpDrop: {
    paramName: 'DKN_UART_D10_LP_DROP_CONTROL_C303_O11_B1',
    labelKey: 'components.assetDetails.dknUartLabels.lpDropControl',
    unit: '', color: 'rgba(59, 130, 246, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10FinTempDrop: {
    paramName: 'DKN_UART_D10_FIN_TEMP_DROP_CONTROL_C307_O12_B1',
    labelKey: 'components.assetDetails.dknUartLabels.finTempDropControl',
    unit: '', color: 'rgba(168, 85, 247, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD10OtherDrop: {
    paramName: 'DKN_UART_D10_OTHER_DROP_CONTROL_C303_O12_B1',
    labelKey: 'components.assetDetails.dknUartLabels.otherDropControl',
    unit: '', color: 'rgba(156, 163, 175, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  // DKN UART D10 — protection retry counts
  dknUartD10DischargeTempRetries: {
    paramName: 'DKN_UART_D10_DISCHARGE_TEMP_PROTECTION_RETRY_QTY_C310_O10_B1',
    labelKey: 'components.assetDetails.dknUartLabels.dischargeTempProtRetries',
    unit: '', color: 'rgba(220, 38, 38, 0.85)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD10CompInvCurrentRetries: {
    paramName: 'DKN_UART_D10_COMP_INV_CURRENT_PROTECTION_RETRY_QTY_C311_O10_B1',
    labelKey: 'components.assetDetails.dknUartLabels.compInvCurrentProtRetries',
    unit: '', color: 'rgba(234, 179, 8, 0.85)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD10HpRetries: {
    paramName: 'DKN_UART_D10_HP_PROTECTION_RETRY_QTY_C310_O11_B1',
    labelKey: 'components.assetDetails.dknUartLabels.hpProtRetries',
    unit: '', color: 'rgba(16, 185, 129, 0.85)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD10LpRetries: {
    paramName: 'DKN_UART_D10_LP_PROTECTION_RETRY_QTY_C311_O11_B1',
    labelKey: 'components.assetDetails.dknUartLabels.lpProtRetries',
    unit: '', color: 'rgba(56, 189, 248, 0.85)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD10FinTempRetries: {
    paramName: 'DKN_UART_D10_FIN_TEMP_PROTECTION_RETRY_QTY_C310_O12_B1',
    labelKey: 'components.assetDetails.dknUartLabels.finTempProtRetries',
    unit: '', color: 'rgba(139, 92, 246, 0.85)', axisId: 'dknUartCount', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  // DKN UART D20 — outdoor temps & low pressure
  dknUartD20OutdoorAirTemp: {
    paramName: 'DKN_UART_D20_OUTDOOR_AIR_TEMP_C105_O0_B2',
    labelKey: 'components.assetDetails.dknUartLabels.outdoorAirTemp',
    unit: '°C', color: 'rgba(239, 68, 68, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD20Ti: {
    paramName: 'DKN_UART_D20_TI_C105_O2_B2',
    labelKey: 'components.assetDetails.dknUartLabels.ti',
    unit: '°C', color: 'rgba(249, 115, 22, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD20Tl: {
    paramName: 'DKN_UART_D20_TL_C105_O4_B2',
    labelKey: 'components.assetDetails.dknUartLabels.tl',
    unit: '°C', color: 'rgba(234, 179, 8, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD20Tg: {
    paramName: 'DKN_UART_D20_TG_C105_O6_B2',
    labelKey: 'components.assetDetails.dknUartLabels.tg',
    unit: '°C', color: 'rgba(132, 204, 22, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD20Td1: {
    paramName: 'DKN_UART_D20_TD1_C105_O8_B2',
    labelKey: 'components.assetDetails.dknUartLabels.td1',
    unit: '°C', color: 'rgba(20, 184, 166, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD20LowPressure1: {
    paramName: 'DKN_UART_D20_LOW_PRESSURE_1_C105_O14_B2',
    labelKey: 'components.assetDetails.dknUartLabels.lowPressure1',
    unit: 'bar', color: 'rgba(99, 102, 241, 0.85)', axisId: 'dknUartPressure', axisPosition: 'left',
    tickFormatter: (v) => `${v} bar`
  },
  dknUartD20LowPressure1T: {
    paramName: 'DKN_UART_D20_LOW_PRESSURE_1_T_C405_O14_B2',
    labelKey: 'components.assetDetails.dknUartLabels.lowPressure1T',
    unit: '°C', color: 'rgba(139, 92, 246, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  // DKN UART D21 — high pressure & currents
  dknUartD21HighPressure: {
    paramName: 'DKN_UART_D21_HIGH_PRESSURE_C105_O0_B2',
    labelKey: 'components.assetDetails.dknUartLabels.highPressure',
    unit: 'bar', color: 'rgba(220, 38, 38, 0.85)', axisId: 'dknUartPressure', axisPosition: 'left',
    tickFormatter: (v) => `${v} bar`
  },
  dknUartD21HighPressureT: {
    paramName: 'DKN_UART_D21_HIGH_PRESSURE_T_C405_O0_B2',
    labelKey: 'components.assetDetails.dknUartLabels.highPressureT',
    unit: '°C', color: 'rgba(239, 68, 68, 0.75)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD21InvCurrent: {
    paramName: 'DKN_UART_D21_INV_SECONDARY_CURRENT_A_C105_O2_B2',
    labelKey: 'components.assetDetails.dknUartLabels.invCurrent',
    unit: 'A', color: 'rgba(245, 158, 11, 0.85)', axisId: 'dknUartCurrent', axisPosition: 'right',
    tickFormatter: (v) => `${v} A`
  },
  dknUartD21InvFinTemp: {
    paramName: 'DKN_UART_D21_INV_FIN_TEMP_C105_O8_B2',
    labelKey: 'components.assetDetails.dknUartLabels.invFinTemp',
    unit: '°C', color: 'rgba(251, 146, 60, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  // DKN UART D30 — compressor, fans, EV
  dknUartD30CompressorFreq: {
    paramName: 'DKN_UART_D30_COMPRESSOR_ROTATION_FREQUENCY_RPS_C152_O0_B1',
    labelKey: 'components.assetDetails.dknUartLabels.compressorFreq',
    unit: 'rps', color: 'rgba(16, 185, 129, 0.85)', axisId: 'dknUartFreq', axisPosition: 'left',
    tickFormatter: (v) => `${v} rps`
  },
  dknUartD30Fan1: {
    paramName: 'DKN_UART_D30_FAN_1_STEP_C211_O2_B1',
    labelKey: 'components.assetDetails.dknUartLabels.fan1',
    unit: '', color: 'rgba(6, 182, 212, 0.85)', axisId: 'dknUartFanStep', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD30Fan2: {
    paramName: 'DKN_UART_D30_FAN_2_STEP_C211_O3_B1',
    labelKey: 'components.assetDetails.dknUartLabels.fan2',
    unit: '', color: 'rgba(14, 165, 233, 0.85)', axisId: 'dknUartFanStep', axisPosition: 'left',
    tickFormatter: (v) => `${v}`
  },
  dknUartD30R1: {
    paramName: 'DKN_UART_D30_R1_C305_O12_B1',
    labelKey: 'components.assetDetails.dknUartLabels.r1',
    unit: '', color: 'rgba(16, 185, 129, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD30Warning: {
    paramName: 'DKN_UART_D30_WARNING_C304_O12_B1',
    labelKey: 'components.assetDetails.dknUartLabels.warning',
    unit: '', color: 'rgba(234, 179, 8, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD30BackUp: {
    paramName: 'DKN_UART_D30_BACK_UP_C303_O12_B1',
    labelKey: 'components.assetDetails.dknUartLabels.backUp',
    unit: '', color: 'rgba(220, 38, 38, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD30Ev2: {
    paramName: 'DKN_UART_D30_EXPANSION_VALVE_2_PLS_C151_O6_B2',
    labelKey: 'components.assetDetails.dknUartLabels.ev2',
    unit: 'pls', color: 'rgba(139, 92, 246, 0.85)', axisId: 'dknUartEv', axisPosition: 'left',
    tickFormatter: (v) => `${v} pls`
  },
  dknUartD30Ev3: {
    paramName: 'DKN_UART_D30_EXPANSION_VALVE_3_PLS_C151_O8_B2',
    labelKey: 'components.assetDetails.dknUartLabels.ev3',
    unit: 'pls', color: 'rgba(167, 139, 250, 0.85)', axisId: 'dknUartEv', axisPosition: 'left',
    tickFormatter: (v) => `${v} pls`
  },
  // DKN UART D50 — indoor unit
  dknUartD50OperationMode: {
    paramName: 'DKN_UART_D50_INDOOR_OPERATION_MODE_NUM_C313_O2_B1',
    labelKey: 'components.assetDetails.dknUartLabels.indoorOperationMode',
    unit: '', color: 'rgba(99, 102, 241, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD50ErrorCode: {
    paramName: 'DKN_UART_D50_ERROR_CODE_NUM_C204_O3_B1',
    labelKey: 'components.assetDetails.dknUartLabels.indoorErrorCode',
    unit: '', color: 'rgba(220, 38, 38, 0.9)', axisId: 'dknStatus', axisPosition: 'left',
    axisTitle: 'components.assetDetails.dknAxisTitles.status'
  },
  dknUartD50Setpoint: {
    paramName: 'DKN_UART_D50_R_C_SETPOINT_NUM_C107_O7_B2',
    labelKey: 'components.assetDetails.dknUartLabels.indoorSetpoint',
    unit: '°C', color: 'rgba(234, 179, 8, 0.9)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD50SuctionTemp: {
    paramName: 'DKN_UART_D50_INDOOR_SUCTION_AIR_TEMP_NUM_C107_O9_B2',
    labelKey: 'components.assetDetails.dknUartLabels.indoorSuctionTemp',
    unit: '°C', color: 'rgba(249, 115, 22, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD50LiquidTemp: {
    paramName: 'DKN_UART_D50_INDOOR_LIQUID_PIPE_TEMP_NUM_C107_O11_B2',
    labelKey: 'components.assetDetails.dknUartLabels.indoorLiquidTemp',
    unit: '°C', color: 'rgba(20, 184, 166, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD50GasTemp: {
    paramName: 'DKN_UART_D50_INDOOR_GAS_PIPE_TEMP_NUM_C107_O13_B2',
    labelKey: 'components.assetDetails.dknUartLabels.indoorGasTemp',
    unit: '°C', color: 'rgba(6, 182, 212, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD50IndoorEv: {
    paramName: 'DKN_UART_D50_INDOOR_EXPANSION_VALVE_PLS_NUM_C151_O15_B2',
    labelKey: 'components.assetDetails.dknUartLabels.indoorEv',
    unit: 'pls', color: 'rgba(139, 92, 246, 0.85)', axisId: 'dknUartEv', axisPosition: 'left',
    tickFormatter: (v) => `${v} pls`
  },
  // DKN UART D70 — booster unit
  dknUartD70Ti: {
    paramName: 'DKN_UART_D70_TI_NUM_C105_O4_B2',
    labelKey: 'components.assetDetails.dknUartLabels.boosterTi',
    unit: '°C', color: 'rgba(239, 68, 68, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD70Tg: {
    paramName: 'DKN_UART_D70_TG_NUM_C105_O6_B2',
    labelKey: 'components.assetDetails.dknUartLabels.boosterTg',
    unit: '°C', color: 'rgba(249, 115, 22, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD70Td: {
    paramName: 'DKN_UART_D70_TD_NUM_C105_O8_B2',
    labelKey: 'components.assetDetails.dknUartLabels.boosterTd',
    unit: '°C', color: 'rgba(234, 179, 8, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD70LowPressure: {
    paramName: 'DKN_UART_D70_LOW_PRESSURE_NUM_C105_O10_B2',
    labelKey: 'components.assetDetails.dknUartLabels.boosterLowPressure',
    unit: 'bar', color: 'rgba(99, 102, 241, 0.85)', axisId: 'dknUartPressure', axisPosition: 'left',
    tickFormatter: (v) => `${v} bar`
  },
  dknUartD70LowPressureT: {
    paramName: 'DKN_UART_D70_LOW_PRESSURE_NUM_T_C405_O10_B2',
    labelKey: 'components.assetDetails.dknUartLabels.boosterLowPressureT',
    unit: '°C', color: 'rgba(139, 92, 246, 0.85)', axisId: 'dknUartTemp', axisPosition: 'left',
    tickFormatter: (v) => `${v} °C`
  },
  dknUartD70CompressorFreq: {
    paramName: 'DKN_UART_D70_COMPRESSOR_ROTATION_FREQUENCY_RPS_NUM_C152_O14_B1',
    labelKey: 'components.assetDetails.dknUartLabels.boosterCompressorFreq',
    unit: 'rps', color: 'rgba(16, 185, 129, 0.85)', axisId: 'dknUartFreq', axisPosition: 'left',
    tickFormatter: (v) => `${v} rps`
  },
  // DKN UART — computed superheat values (derived from existing series)
  dknUartSuctionSh: {
    paramName: 'dknUartSuctionSh',
    labelKey: 'components.assetDetails.dknUartLabels.suctionSh',
    unit: 'K', color: 'rgba(56, 189, 248, 0.85)', axisId: 'dknUartSuperheat', axisPosition: 'left',
    tickFormatter: (v) => `${v} K`
  },
  dknUartDischargeSh: {
    paramName: 'dknUartDischargeSh',
    labelKey: 'components.assetDetails.dknUartLabels.dischargeSh',
    unit: 'K', color: 'rgba(245, 158, 11, 0.85)', axisId: 'dknUartSuperheat', axisPosition: 'left',
    tickFormatter: (v) => `${v} K`
  }
}

export const SERIES_KEYS = Object.keys(SERIES_META) as SeriesKey[]

export type WagoAxisConfig = {
  axisId: string
  unit: string
  position: 'left' | 'right'
  stepSize?: number
}

export type WagoChartGroup = {
  id: string
  titleKey: string
  keys: SeriesKey[]
  unit: string
  minY?: number
  maxY?: number
  yMultiplier?: number
  axisPerKey?: Partial<Record<SeriesKey, WagoAxisConfig>>
}

export const WAGO_CHART_GROUPS: WagoChartGroup[] = [
  {
    id: 'energy',
    titleKey: 'components.assetDetails.wagoLabels.chart_energy',
    keys: ['wagoEnergyActive', 'wagoEnergyReactive'],
    unit: '',
    axisPerKey: {
      wagoEnergyActive:   { axisId: 'y_kwh',   unit: 'kWh',   position: 'left', stepSize: 0.01 },
      wagoEnergyReactive: { axisId: 'y_kvarh', unit: 'kvarh', position: 'left', stepSize: 5 }
    }
  },
  { id: 'power',        titleKey: 'components.assetDetails.wagoLabels.chart_power',        keys: ['wagoPowerL1', 'wagoPowerL2', 'wagoPowerL3'],           unit: 'W', yMultiplier: 1000 },
  { id: 'current',      titleKey: 'components.assetDetails.wagoLabels.chart_current',      keys: ['wagoCurrentL1', 'wagoCurrentL2', 'wagoCurrentL3'],     unit: 'A' },
  { id: 'voltage-ln',   titleKey: 'components.assetDetails.wagoLabels.chart_voltage_ln',   keys: ['wagoVoltLNL1', 'wagoVoltLNL2', 'wagoVoltLNL3'],        unit: 'V' },
  { id: 'voltage-ll',   titleKey: 'components.assetDetails.wagoLabels.chart_voltage_ll',   keys: ['wagoVoltLLL1L2', 'wagoVoltLLL2L3', 'wagoVoltLLL1L3'],  unit: 'V' },
  { id: 'power-factor', titleKey: 'components.assetDetails.wagoLabels.chart_power_factor', keys: ['wagoPfL1', 'wagoPfL2', 'wagoPfL3'],                    unit: '', minY: 0, maxY: 1.1 },
]

export type DknChartGroup = {
  id: string
  titleKey: string
  keys: SeriesKey[]
  mode?: 'line' | 'step' | 'statusTimeline' | 'virtualProbe'
}

export const DKN_LMS_CHART_GROUPS: DknChartGroup[] = [
  {
    id: 'temp-main',
    titleKey: 'components.assetDetails.dknGroupTitles.tempMain',
    keys: ['dknLmsSc', 'dknLmsSdt', 'dknLmsTgs', 'dknLmsTeu']
  },
  {
    id: 'virtual-probe',
    titleKey: 'components.assetDetails.dknGroupTitles.virtualProbe',
    keys: ['dknLmsSv'],
    mode: 'virtualProbe'
  },
  {
    id: 'superheat',
    titleKey: 'components.assetDetails.dknGroupTitles.superheat',
    keys: ['dknLmsSh', 'dknLmsShb']
  },
  {
    id: 'control',
    titleKey: 'components.assetDetails.dknGroupTitles.control',
    keys: ['dknLmsVsr', 'dknLmsPpu', 'dknLmsPpub'],
    mode: 'step'
  },
  {
    id: 'alarm-count',
    titleKey: 'components.assetDetails.dknGroupTitles.alarmCount',
    keys: ['dknLmsAlr'],
    mode: 'step'
  },
  {
    id: 'alarm-flags',
    titleKey: 'components.assetDetails.dknGroupTitles.alarmFlags',
    keys: ['dknLmsCht', 'dknLmsFia', 'dknLmsHi', 'dknLmsGlo', 'dknLmsU1'],
    mode: 'statusTimeline'
  },
  {
    id: 'fan-outputs',
    titleKey: 'components.assetDetails.dknGroupTitles.fanOutputs',
    keys: ['dknLmsFoi', 'dknLmsFot'],
    mode: 'statusTimeline'
  },
  {
    id: 'setpoints',
    titleKey: 'components.assetDetails.dknGroupTitles.setpoints',
    keys: ['dknLmsSt', 'dknLmsAh', 'dknLmsAl', 'dknLmsR4'],
    mode: 'step'
  },
  {
    id: 'temp-circuit-2',
    titleKey: 'components.assetDetails.dknGroupTitles.tempCircuit2',
    keys: ['dknLmsScb', 'dknLmsSdtb', 'dknLmsTgsb', 'dknLmsTeub']
  },
  {
    id: 'lms-gateway',
    titleKey: 'components.assetDetails.mpsGroupTitles.gateway',
    keys: ['devPowerSupply', 'devBattery']
  }
]

export const DKN_MPS_CHART_GROUPS: DknChartGroup[] = [
  {
    id: 'mps-temp',
    titleKey: 'components.assetDetails.mpsGroupTitles.temperature',
    keys: ['dknMpsProbe1', 'dknMpsProbe2', 'dknMpsDisplayedProbe', 'dknMpsTempRegProbe']
  },
  {
    id: 'mps-setpoints',
    titleKey: 'components.assetDetails.mpsGroupTitles.setpoints',
    keys: ['dknMpsSetpoint', 'dknMpsSetpointActive'],
    mode: 'step'
  },
  {
    id: 'mps-statuses',
    titleKey: 'components.assetDetails.mpsGroupTitles.statuses',
    keys: ['dknMpsStatusOnOff', 'dknMpsStatusDefrost', 'dknMpsStatusCooling', 'dknMpsDiDoor'],
    mode: 'statusTimeline'
  },
  {
    id: 'mps-outputs',
    titleKey: 'components.assetDetails.mpsGroupTitles.outputs',
    keys: ['dknMpsDoComp1', 'dknMpsDoComp2', 'dknMpsDoEvapFan'],
    mode: 'statusTimeline'
  },
  {
    id: 'mps-alarms',
    titleKey: 'components.assetDetails.mpsGroupTitles.alarms',
    keys: ['dknMpsAlarmHighTemp', 'dknMpsAlarmLowTemp'],
    mode: 'statusTimeline'
  },
  {
    id: 'mps-gateway',
    titleKey: 'components.assetDetails.mpsGroupTitles.gateway',
    keys: ['devPowerSupply', 'devBattery']
  }
]

export const DKN_UART_CHART_GROUPS: DknChartGroup[] = [
  {
    id: 'uart-outdoor-temps',
    titleKey: 'components.assetDetails.dknUartGroupTitles.outdoorTemps',
    keys: ['dknUartD20OutdoorAirTemp', 'dknUartD20Ti', 'dknUartD20Tl', 'dknUartD20Tg', 'dknUartD20Td1', 'dknUartD21InvFinTemp']
  },
  {
    id: 'uart-superheat',
    titleKey: 'components.assetDetails.dknUartGroupTitles.superheat',
    keys: ['dknUartSuctionSh', 'dknUartDischargeSh']
  },
  {
    id: 'uart-pressures',
    titleKey: 'components.assetDetails.dknUartGroupTitles.pressures',
    keys: ['dknUartD20LowPressure1', 'dknUartD21HighPressure', 'dknUartD10TargetEvapPress']
  },
  {
    id: 'uart-pressure-temps',
    titleKey: 'components.assetDetails.dknUartGroupTitles.pressureTemps',
    keys: ['dknUartD20LowPressure1T', 'dknUartD21HighPressureT']
  },
  {
    id: 'uart-compressor',
    titleKey: 'components.assetDetails.dknUartGroupTitles.compressor',
    keys: ['dknUartD30CompressorFreq', 'dknUartD21InvCurrent']
  },
  {
    id: 'uart-fans',
    titleKey: 'components.assetDetails.dknUartGroupTitles.fans',
    keys: ['dknUartD30Fan1', 'dknUartD30Fan2'],
    mode: 'step'
  },
  {
    id: 'uart-ev',
    titleKey: 'components.assetDetails.dknUartGroupTitles.expansionValves',
    keys: ['dknUartD30Ev2', 'dknUartD30Ev3', 'dknUartD50IndoorEv']
  },
  {
    id: 'uart-diagnostics',
    titleKey: 'components.assetDetails.dknUartGroupTitles.diagnostics',
    keys: ['dknUartD10ErrorType', 'dknUartD10ErrorCode']
  },
  {
    id: 'uart-statuses',
    titleKey: 'components.assetDetails.dknUartGroupTitles.d10Flags',
    keys: [
      'dknUartD10OperationMode', 'dknUartD10ThermostatOnOff', 'dknUartD10Defrost',
      'dknUartD10RestartStandby', 'dknUartD10OilReturn', 'dknUartD10PressureEqualizing',
      'dknUartD10DemandSignal', 'dknUartD10ModeCompletion', 'dknUartD10LowNoiseControl',
      'dknUartD30R1', 'dknUartD30Warning', 'dknUartD30BackUp'
    ],
    mode: 'statusTimeline'
  },
  {
    id: 'uart-d10protection-drops',
    titleKey: 'components.assetDetails.dknUartGroupTitles.d10Protection',
    keys: [
      'dknUartD10DischargeTempDrop',
      'dknUartD10CompInvCurrentDrop',
      'dknUartD10HpDrop',
      'dknUartD10LpDrop',
      'dknUartD10FinTempDrop',
      'dknUartD10OtherDrop'
    ],
    mode: 'statusTimeline'
  },
  {
    id: 'uart-d10protection-retries',
    titleKey: 'components.assetDetails.dknUartGroupTitles.d10ProtectionRetries',
    keys: [
      'dknUartD10DischargeTempRetries',
      'dknUartD10CompInvCurrentRetries',
      'dknUartD10HpRetries',
      'dknUartD10LpRetries',
      'dknUartD10FinTempRetries'
    ],
    mode: 'step'
  },
  {
    id: 'uart-indoor',
    titleKey: 'components.assetDetails.dknUartGroupTitles.indoor',
    keys: ['dknUartD50Setpoint', 'dknUartD50SuctionTemp', 'dknUartD50LiquidTemp', 'dknUartD50GasTemp']
  },
  {
    id: 'uart-booster',
    titleKey: 'components.assetDetails.dknUartGroupTitles.booster',
    keys: ['dknUartD70Ti', 'dknUartD70Tg', 'dknUartD70Td', 'dknUartD70LowPressure', 'dknUartD70LowPressureT', 'dknUartD70CompressorFreq']
  },
  {
    id: 'uart-gateway',
    titleKey: 'components.assetDetails.mpsGroupTitles.gateway',
    keys: ['devPowerSupply', 'devBattery']
  }
]

export const GATEWAY_SERIES_KEYS = new Set<SeriesKey>(['devPowerSupply', 'devBattery'])

const DEVICE_SERIES_KEYS = new Set<SeriesKey>([
  'xAxis',
  'yAxis',
  'zAxis',
  'magnitude',
  'magnitudeNoGravity'
])

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

function toFiniteNumber(value: unknown): number | null {
  const numeric = typeof value === 'number' ? value : typeof value === 'string' ? parseFloat(value) : NaN
  return Number.isFinite(numeric) ? numeric : null
}

function normalizeVoltageMillivolts(value: number): number {
  return parseFloat((value / 1000).toFixed(2))
}

export const GRAVITY_MG = 1000

const MODBUS_OUTLIER_THRESHOLD = 1e9

function isModbusSeriesKey(key: SeriesKey): boolean {
  return key.startsWith('wago')
}

export function computeAxisMagnitude(x: number, y: number, z: number): number {
  return Math.hypot(x, y, z)
}

export function computeAxisMagnitudeNoGravity(magnitude: number): number {
  return Math.max(0, magnitude - GRAVITY_MG)
}

export function transformSeriesPoints(key: SeriesKey, points: RawChartPoint[] | null | undefined): ChartPoint[] {
  if (!Array.isArray(points) || !points.length) return []

  const normalized: ChartPoint[] = []
  points.forEach((point) => {
    const x = typeof point?.x === 'number' ? point.x : NaN
    if (!Number.isFinite(x)) return

    const numericY = toFiniteNumber(point?.y)
    if (numericY === null) return

    if (isModbusSeriesKey(key) && Math.abs(numericY) > MODBUS_OUTLIER_THRESHOLD) {
      console.warn('[modbus] extreme series value', { key, x, y: numericY, threshold: MODBUS_OUTLIER_THRESHOLD })
      return
    }

    let y = key === 'powerSupply' || key === 'batteryVoltage' || key === 'devPowerSupply' || key === 'devBattery'
      ? normalizeVoltageMillivolts(numericY)
      : numericY

    if (key === 'magnitude' || key === 'magnitudeNoGravity') {
      y = Number(y.toFixed(2))
    }

    normalized.push({ x, y })
  })

  return normalized
}

export function buildSeriesRecord(rawSeries: unknown, t: (key: string) => string): ChartSeriesRecord {
  const series = isRecord(rawSeries) ? (rawSeries as RawChartSeriesMap) : {}
  const record = {} as ChartSeriesRecord

  SERIES_KEYS.forEach((key) => {
    const meta = SERIES_META[key]
    const payload = series?.[key]
    const payloadLabel = typeof payload?.label === 'string' ? payload.label : null
    const metaLabel = t(meta.labelKey)
    const useMetaLabel = meta.labelKey.startsWith('components.assetDetails.') || DEVICE_SERIES_KEYS.has(key)
    const resolvedLabel = useMetaLabel
      ? metaLabel
      : (payloadLabel && payloadLabel.startsWith('components.')
        ? t(payloadLabel)
        : (payloadLabel ?? metaLabel))

    record[key] = {
      paramName: payload?.paramName ?? meta.paramName,
      label: resolvedLabel,
      unit: payload?.unit ?? meta.unit,
      points: transformSeriesPoints(key, payload?.points)
    }
  })

  return record
}

export function clipSeriesRecordByTimeRange(
  seriesRecord: ChartSeriesRecord,
  rangeStartMs: number,
  rangeEndMs: number
): ChartSeriesRecord {
  const clipped = {} as ChartSeriesRecord

  SERIES_KEYS.forEach((key) => {
    const series = seriesRecord[key]
    clipped[key] = {
      ...series,
      points: series.points.filter((point) => point.x >= rangeStartMs && point.x <= rangeEndMs)
    }
  })

  return clipped
}
